module.exports = __webpack_public_path__ + "static/media/OurWorkCategory.ed4021ce.svg";